export default "__VITE_ASSET__Umw4y$Vs__"